export const headerBrandName = "F5gumd";
export default {headerBrandName};